import React, { useState } from "react";
import {
  Box,
  useMediaQuery,
  useTheme,
  IconButton,
  Drawer,
  Typography,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import Navbar from "../components/Navbar";
import LeftBar from "../components/LeftBar";
import Icon from "../components/MUI/Icon";

const Layout = ({
  children,
  isSidebar = true,
  isNavbar = true,
  isSubNavbar = false,
  sidebarData,
  navbarData,
  subNavbarData,
}) => {
  const theme = useTheme();
  const showLeftBar = useMediaQuery("(min-width:1100px)");
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <Box maxWidth="1440px" width="100%" >
      {isNavbar && <Navbar {...navbarData} />}
      {isSubNavbar && (
        <Box sx={{ ...subNavbarData?.style ,justifyContent:"space-between" }}>
           <Icon style={subNavbarData?.icn1?.style}>
          <span
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            dangerouslySetInnerHTML={{ __html: subNavbarData?.icn1?.icon }}
          />
        </Icon>

          <Box display="flex" alignItems="center" gap="8px">
            <Typography sx={{ ...subNavbarData?.str1?.style }}>
              {subNavbarData?.str1?.label || "Sub Navbar Title"}
            </Typography>
            <Typography sx={{ ...subNavbarData?.str2?.style }}>
              {subNavbarData?.str2?.label || "Sub Navbar Description"}
            </Typography>
          </Box>
        </Box>
      )}
      <Box display="flex" width="100%">
        {isSidebar && showLeftBar && <LeftBar {...sidebarData} />}

        <Drawer
          anchor="left"
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
        >
          <Box
            width="100%"
            role="presentation"
            onClick={() => setDrawerOpen(false)}
          >
            <LeftBar {...sidebarData} />
          </Box>
        </Drawer>

        {!showLeftBar && isSidebar && (
          <IconButton
            sx={{ position: "fixed", zIndex: 1000 }}
            onClick={() => setDrawerOpen(true)}
          >
            <MenuIcon />
          </IconButton>
        )}

        <Box flex={1}>{children}</Box>
      </Box>
    </Box>
  );
};

export default Layout;
